import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c4ced6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"background":"#fff","margin-top":"20px"},
  class: "custom"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleBox" }, "自定义参数", -1))
const _hoisted_3 = { class: "centerBox" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_Form_item = _resolveComponent("Form-item")!

  return (_ctx.checkCustom.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datalist.extraList, (item, index) => {
            return (_openBlock(), _createBlock(_component_Form_item, {
              key: index,
              label: item.extraName,
              name: item.extraCode,
              class: "formItem",
              rules: _ctx.checkCustom[index]
            }, {
              default: _withCtx(() => [
                (item.extraType === 'text' || item.extraType === 'number')
                  ? (_openBlock(), _createBlock(_component_Input, {
                      key: 0,
                      value: _ctx.datalist[item.extraCode],
                      "onUpdate:value": ($event: any) => ((_ctx.datalist[item.extraCode]) = $event),
                      type: item.extraType,
                      placeholder: item.extraTips,
                      disabled: _ctx.handleDisable(item) || !_ctx.todoEdit,
                      class: _normalizeClass(_ctx.todoEdit ? '' : 'noBoder')
                    }, null, 8, ["value", "onUpdate:value", "type", "placeholder", "disabled", "class"]))
                  : (item.extraType === 'radio')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_a_radio_group, {
                            name: _ctx.datalist[item.extraCode],
                            value: _ctx.datalist[item.extraCode],
                            "onUpdate:value": ($event: any) => ((_ctx.datalist[item.extraCode]) = $event)
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.selectValue.split(';'), (data, index) => {
                                return (_openBlock(), _createBlock(_component_a_radio, {
                                  value: data,
                                  key: index,
                                  disabled: !_ctx.todoEdit
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(data), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "disabled"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["name", "value", "onUpdate:value"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_a_checkbox_group, {
                            name: _ctx.datalist[item.extraCode],
                            onChange: ($event: any) => (_ctx.changeChenkBox($event, item.extraCode)),
                            value: _ctx.computedCheckboxValue(_ctx.datalist[item.extraCode]),
                            options: item.selectValue.split(';'),
                            disabled: !_ctx.todoEdit
                          }, null, 8, ["name", "onChange", "value", "options", "disabled"])
                        ])
                      ]))
              ]),
              _: 2
            }, 1032, ["label", "name", "rules"]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}